import { BusinessRelationshipV11 } from './businessRelationshipV11';
export class BusinessPartnerV11 {
    static constructFromPlainObjectList(objList) {
        const businessPartners = [];
        if (objList && Array.isArray(objList)) {
            for (const obj of objList) {
                businessPartners.push(BusinessPartnerV11.constructFromPlainObject(obj));
            }
        }
        return businessPartners;
    }
    constructor() {
        this.businessPartnerId = null;
        this.city = null;
        this.distributionPartnerNumber = null;
        this.outletName = null;
        this.outletNumber = null;
        this.street = null;
        this.zipCode = null;
        this.businessRelationships = [];
    }
    getBusinessPartnerId() {
        return this.businessPartnerId;
    }
    setBusinessPartnerId(value) {
        this.businessPartnerId = value;
    }
    getCity() {
        return this.city;
    }
    setCity(value) {
        this.city = value;
    }
    getDistributionPartnerNumber() {
        return this.distributionPartnerNumber;
    }
    setDistributionPartnerNumber(value) {
        this.distributionPartnerNumber = value;
    }
    getOutletName() {
        return this.outletName;
    }
    setOutletName(value) {
        this.outletName = value;
    }
    getOutletNumber() {
        return this.outletNumber;
    }
    setOutletNumber(value) {
        this.outletNumber = value;
    }
    getStreet() {
        return this.street;
    }
    setStreet(value) {
        this.street = value;
    }
    getZipCode() {
        return this.zipCode;
    }
    setZipCode(value) {
        this.zipCode = value;
    }
    getBusinessRelationships() {
        return this.businessRelationships;
    }
    setBusinessRelationships(value) {
        this.businessRelationships = value;
    }
}
BusinessPartnerV11.constructFromPlainObject = (source) => {
    let target = new BusinessPartnerV11();
    target = Object.assign(target, source);
    if (source.businessRelationships) {
        target.businessRelationships = BusinessRelationshipV11.constructFromPlainObjectList(source.businessRelationships);
    }
    return target;
};
//# sourceMappingURL=businessPartnerV11.js.map